<p>2025</p>
<p>The Internet is Bad now and Walter Benjamin predicted why all the way back in 1936 – a video essay on five minute crafts, generative AI, instagram face, sludge, Jaclyn Hill’s hairy lipsticks, and the enduring aura of Bill Viola’s <em>Ocean Without a Shore</em>.</p>
<app-embedded-video [videoId]="videoId"></app-embedded-video>
